import React, { FC, useCallback } from 'react';
import styled from 'styled-components';
import { Select, SelectProps } from 'antd';
import { NoContentItem } from '../common/components';
import { Role } from './types';

export interface RoleSelectProps extends SelectProps<number | number[]> {
  roles: Role[];
}

export const RoleSelect: FC<RoleSelectProps> = (props) => {
  const { roles } = props;
  const options = roles.map((role) => ({
    value: role.id,
    label: role.name,
  }));

  const filterOption = useCallback(
    (input: string, option?: { label: string; value: string }) => {
      return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
    },
    []
  );

  return (
    <StyledRoleSelect
      {...props}
      showSearch
      options={options}
      filterOption={filterOption}
      notFoundContent={<NoContentItem />}
      styles={{
        popup: { root: { width: 'max-content', ...props.dropdownStyle } },
      }}
    />
  );
};

const StyledRoleSelect = styled(Select<any, any>)`
  min-width: 8em;
`;
